import { render, staticRenderFns } from "./detailPopup.vue?vue&type=template&id=37f87935&scoped=true&"
import script from "./detailPopup.vue?vue&type=script&lang=js&"
export * from "./detailPopup.vue?vue&type=script&lang=js&"
import style0 from "./detailPopup.vue?vue&type=style&index=0&id=37f87935&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f87935",
  null
  
)

export default component.exports